import { useState } from "react";
import { useSearchContext } from "../contexts/searchcontext.ts";
import { Checkbox, Input } from "antd";

const OptionListFiltered = ({ heading, fieldName, selectionsChanged, hideByDefault, hideSearch }) => {
  const [searchFilter, setSearchFilter] = useState("");
  const searchContext = useSearchContext();

  const filterItems = (item) => {
    if (searchFilter === "") {
      return !hideByDefault;
    }
    const reg = new RegExp(searchFilter, "ig");
    return item.label.search(reg) > -1;
  };

  const selectionChanged = (event) => {
    const existing = searchContext[fieldName + "Selected"];
    let newItemsSelected = [...existing];

    if (event.target.checked) {
      newItemsSelected.push({ value: event.target.id, label: event.target.name });
    } else {
      newItemsSelected = newItemsSelected.filter((item) => item.value !== event.target.id);
    }
    selectionsChanged(fieldName, newItemsSelected);
  };

  const isSelected = (item) => {
    return searchContext[fieldName + "Selected"].some(({ value }) => value === item.value);
  };

  const isFilterable = (item) => {
    return searchContext[fieldName + "Available"].some(({ value }) => value === item.value);
  };

  let filterable = searchContext[fieldName].filter(isFilterable).filter(filterItems);
  const FilterableItemElements = filterable.map((item) => (
    <div key={item.value}>
      <Checkbox id={item.value} name={item.label} checked={isSelected(item)} onChange={selectionChanged}>
        {item.label}
      </Checkbox>
    </div>
  ));

  const setFilter = (event) => {
    setSearchFilter(event.target.value);
  };

  return (
    <div>
      {!hideSearch && <Input.Search placeholder={"Filter " + heading} onChange={setFilter} />}
      {hideByDefault && !searchFilter && <div style={{ marginTop: 5, fontSize: 11 }}>Type to find {heading}</div>}
      {FilterableItemElements}
    </div>
  );
};

export default OptionListFiltered;
